import type { Artwork } from "./types";

export const ipadWorks: Artwork[] = [
  {
    id: "ip1",
    title: "Photo 2025-07-02, 1 51 58 AM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-07-02-1-51-58-am.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-07-02, 1 51 58 AM.jpg",
    date: "2025-07-02",
  },
  {
    id: "ip2",
    title: "Photo 2025-07-05, 12 45 06 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-07-05-12-45-06-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-07-05, 12 45 06 PM.jpg",
    date: "2025-07-05",
  },
  {
    id: "ip3",
    title: "Photo 2025-07-05, 12 48 06 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-07-05-12-48-06-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-07-05, 12 48 06 PM.jpg",
    date: "2025-07-05",
  },
  {
    id: "ip4",
    title: "Photo 2025-07-05, 12 49 44 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-07-05-12-49-44-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-07-05, 12 49 44 PM.jpg",
    date: "2025-07-05",
  },
  {
    id: "ip5",
    title: "Photo 2025-07-05, 12 51 02 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-07-05-12-51-02-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-07-05, 12 51 02 PM.jpg",
    date: "2025-07-05",
  },
  {
    id: "ip6",
    title: "Photo 2025-07-05, 12 51 52 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-07-05-12-51-52-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-07-05, 12 51 52 PM.jpg",
    date: "2025-07-05",
  },
  {
    id: "ip7",
    title: "Photo 2025-07-05, 9 57 30 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-07-05-9-57-30-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-07-05, 9 57 30 PM.jpg",
    date: "2025-07-05",
  },
  {
    id: "ip8",
    title: "Photo 2025-07-07, 10 15 24 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-07-07-10-15-24-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-07-07, 10 15 24 PM.jpg",
    date: "2025-07-07",
  },
  {
    id: "ip9",
    title: "Photo 2025-08-01, 8 43 37 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-08-01-8-43-37-pm.png",
    fullImage: "/gallery/ipad/full/Photo 2025-08-01, 8 43 37 PM.png",
    date: "2025-08-01",
  },
  {
    id: "ip10",
    title: "Photo 2025-10-24, 10 06 43 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-10-24-10-06-43-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-10-24, 10 06 43 PM.jpg",
    date: "2025-10-24",
  },
  {
    id: "ip11",
    title: "Photo 2025-10-29, 10 26 10 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-10-29-10-26-10-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-10-29, 10 26 10 PM.jpg",
    date: "2025-10-29",
  },
  {
    id: "ip12",
    title: "Photo 2025-11-08, 6 11 04 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-11-08-6-11-04-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-11-08, 6 11 04 PM.jpg",
    date: "2025-11-08",
  },
  {
    id: "ip13",
    title: "Photo 2025-11-08, 7 27 41 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-11-08-7-27-41-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-11-08, 7 27 41 PM.jpg",
    date: "2025-11-08",
  },
  {
    id: "ip14",
    title: "Photo 2025-11-13, 11 49 41 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-11-13-11-49-41-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-11-13, 11 49 41 PM.jpg",
    date: "2025-11-13",
  },
  {
    id: "ip15",
    title: "Photo 2025-11-15, 9 46 49 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-11-15-9-46-49-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-11-15, 9 46 49 PM.jpg",
    date: "2025-11-15",
  },
  {
    id: "ip16",
    title: "Photo 2025-11-17, 12 53 32 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-11-17-12-53-32-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-11-17, 12 53 32 PM.jpg",
    date: "2025-11-17",
  },
  {
    id: "ip17",
    title: "Photo 2025-11-24, 8 46 28 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-11-24-8-46-28-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-11-24, 8 46 28 PM.jpg",
    date: "2025-11-24",
  },
  {
    id: "ip18",
    title: "Photo 2025-12-02, 7 16 31 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-02-7-16-31-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-02, 7 16 31 PM.jpg",
    date: "2025-12-02",
  },
  {
    id: "ip19",
    title: "Photo 2025-12-09, 12 58 05 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-09-12-58-05-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-09, 12 58 05 PM.jpg",
    date: "2025-12-09",
  },
  {
    id: "ip20",
    title: "Photo 2025-12-10, 4 15 10 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-10-4-15-10-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-10, 4 15 10 PM.jpg",
    date: "2025-12-10",
  },
  {
    id: "ip21",
    title: "Photo 2025-12-15, 2 23 27 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-15-2-23-27-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-15, 2 23 27 PM.jpg",
    date: "2025-12-15",
  },
  {
    id: "ip22",
    title: "Photo 2025-12-16, 2 24 49 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-16-2-24-49-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-16, 2 24 49 PM.jpg",
    date: "2025-12-16",
  },
  {
    id: "ip23",
    title: "Photo 2025-12-17, 10 17 18 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-17-10-17-18-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-17, 10 17 18 PM.jpg",
    date: "2025-12-17",
  },
  {
    id: "ip24",
    title: "Photo 2025-12-17, 7 40 31 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-17-7-40-31-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-17, 7 40 31 PM.jpg",
    date: "2025-12-17",
  },
  {
    id: "ip25",
    title: "Photo 2025-12-17, 8 55 29 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-17-8-55-29-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-17, 8 55 29 PM.jpg",
    date: "2025-12-17",
  },
  {
    id: "ip26",
    title: "Photo 2025-12-20, 10 18 14 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-20-10-18-14-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-20, 10 18 14 PM.jpg",
    date: "2025-12-20",
  },
  {
    id: "ip27",
    title: "Photo 2025-12-26, 3 38 29 PM",
    year: 2025,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2025-12-26-3-38-29-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2025-12-26, 3 38 29 PM.jpg",
    date: "2025-12-26",
  },
  {
    id: "ip28",
    title: "Photo 2026-01-21, 4 21 47 PM",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-01-21-4-21-47-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-01-21, 4 21 47 PM.jpg",
    date: "2026-01-21",
  },
  {
    id: "ip29",
    title: "Photo 2026-01-30, 4 55 10 PM",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-01-30-4-55-10-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-01-30, 4 55 10 PM.jpg",
    date: "2026-01-30",
  },
  {
    id: "ip30",
    title: "Photo 2026-02-06, 4 56 30 PM",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-06-4-56-30-pm.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-06, 4 56 30 PM.jpg",
    date: "2026-02-06",
  },
  {
    id: "ip31",
    title: "Photo 2026-02-08, 1 11 03 AM (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip32",
    title: "Photo 2026-02-08, 1 11 03 AM (10)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-10.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (10).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip33",
    title: "Photo 2026-02-08, 1 11 03 AM (12) (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-12-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (12) (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip34",
    title: "Photo 2026-02-08, 1 11 03 AM (12)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-12.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (12).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip35",
    title: "Photo 2026-02-08, 1 11 03 AM (13)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-13.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (13).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip36",
    title: "Photo 2026-02-08, 1 11 03 AM (14) (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-14-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (14) (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip37",
    title: "Photo 2026-02-08, 1 11 03 AM (14)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-14.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (14).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip38",
    title: "Photo 2026-02-08, 1 11 03 AM (15)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-15.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (15).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip39",
    title: "Photo 2026-02-08, 1 11 03 AM (16) (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-16-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (16) (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip40",
    title: "Photo 2026-02-08, 1 11 03 AM (16)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-16.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (16).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip41",
    title: "Photo 2026-02-08, 1 11 03 AM (17) (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-17-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (17) (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip42",
    title: "Photo 2026-02-08, 1 11 03 AM (17)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-17.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (17).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip43",
    title: "Photo 2026-02-08, 1 11 03 AM (18)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-18.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (18).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip44",
    title: "Photo 2026-02-08, 1 11 03 AM (19) (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-19-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (19) (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip45",
    title: "Photo 2026-02-08, 1 11 03 AM (19)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-19.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (19).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip46",
    title: "Photo 2026-02-08, 1 11 03 AM (2)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-2.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (2).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip47",
    title: "Photo 2026-02-08, 1 11 03 AM (20)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-20.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (20).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip48",
    title: "Photo 2026-02-08, 1 11 03 AM (21) (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-21-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (21) (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip49",
    title: "Photo 2026-02-08, 1 11 03 AM (21)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-21.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (21).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip50",
    title: "Photo 2026-02-08, 1 11 03 AM (22)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-22.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (22).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip51",
    title: "Photo 2026-02-08, 1 11 03 AM (23)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-23.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (23).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip52",
    title: "Photo 2026-02-08, 1 11 03 AM (24) (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-24-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (24) (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip53",
    title: "Photo 2026-02-08, 1 11 03 AM (24)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-24.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (24).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip54",
    title: "Photo 2026-02-08, 1 11 03 AM (25)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-25.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (25).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip55",
    title: "Photo 2026-02-08, 1 11 03 AM (26)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-26.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (26).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip56",
    title: "Photo 2026-02-08, 1 11 03 AM (27)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-27.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (27).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip57",
    title: "Photo 2026-02-08, 1 11 03 AM (3) (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-3-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (3) (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip58",
    title: "Photo 2026-02-08, 1 11 03 AM (3)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-3.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (3).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip59",
    title: "Photo 2026-02-08, 1 11 03 AM (4)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-4.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (4).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip60",
    title: "Photo 2026-02-08, 1 11 03 AM (5)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-5.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (5).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip61",
    title: "Photo 2026-02-08, 1 11 03 AM (6)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-6.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (6).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip62",
    title: "Photo 2026-02-08, 1 11 03 AM (7) (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-7-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (7) (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip63",
    title: "Photo 2026-02-08, 1 11 03 AM (7)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-7.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (7).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip64",
    title: "Photo 2026-02-08, 1 11 03 AM (8)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-03-am-8.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 03 AM (8).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip65",
    title: "Photo 2026-02-08, 1 11 04 AM (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-11-04-am-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 11 04 AM (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip66",
    title: "Photo 2026-02-08, 1 20 04 AM (1)",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-20-04-am-1.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 20 04 AM (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "ip67",
    title: "Photo 2026-02-08, 1 20 04 AM",
    year: 2026,
    medium: "iPad",
    thumbnail: "/gallery/ipad/thumbs/photo-2026-02-08-1-20-04-am.jpg",
    fullImage: "/gallery/ipad/full/Photo 2026-02-08, 1 20 04 AM.jpg",
    date: "2026-02-08",
  },
];
